<div class="borderou-page">
  <h1>Borderou</h1>
  <div class="borderou-page__content">
    <div class="borderou-page__content-buttons">
      <button>
        <img src="../../../assets/icons/refresh.png" alt="" />
      </button>
      <button>
        <img src="../../../assets/icons/print.svg" alt="" />
        <span>Printați</span>
      </button>
      <button>
        <img class="add-btn" src="../../../assets/icons/add.svg" alt="" />
        <span>Adăugați</span>
      </button>
    </div>
    <div class="borderou-page__content-input">
      <label for="tip"
        >Tip Borderou
        <input id="tip" type="text" placeholder="Modificare aviz orar" />
      </label>
      <label for="data"
        >Data
        <input id="data" type="text" placeholder="2023-09-13" />
      </label>
    </div>
  </div>
</div>
